import React from 'react';
import PropTypes from 'prop-types';
import CodeChip from '../atoms/CodeChip';
import LowPriorityIcon from '@material-ui/icons/LowPriority';

const AlarmCode = ({alarmCategory, hasBypass}) => (
  <div style={{position: 'relative'}}>
    {hasBypass && (
      <div
        style={{color: '#ccc', position: 'absolute', top: '3px', left: '-35px'}}
        title="This system has an active bypass"
      >
        <LowPriorityIcon style={{width: '25px', height: '25px'}}/>
      </div>
    )}
    {alarmCategory
      ? <CodeChip code={alarmCategory.toLowerCase()}/>
      : hasBypass
        ? <CodeChip code="yellow"/>
        : ''
    }
  </div>
);

AlarmCode.propTypes = PropTypes.shape({
  alarmCategory: PropTypes.string,
  hasBypass: PropTypes.bool,
}).isRequired;

export default AlarmCode;
